<template>
<div id="preview" class="preview" :class="{ 'is-termsModal': isTermsModal }">
  <Header />

  <div id="header-navi" class="header-navi">
    <router-link :to="{ name: 'custom', query: { customid: customID }}" class="header-navi__back">Back</router-link>
    <h2 class="header-navi__ttl">PREVIEW</h2>
  </div>

  <div class="preview__logo" v-if="customItem['brandMainImage'] !== ''">
    <img :src="customItem['brandMainImage']" alt="Brand Logo" />
  </div>
  <div class="preview__main">
     <swiper :options="swiperOption" class="preview__main__img">
      <swiper-slide v-for="(item, index) in customItem.customImage" class="preview__main__img__item" :key="index">
        <img :src="item.filename" :alt="item.label" />
      </swiper-slide>
      <div class="preview__main__img__left swiper-button-prev" slot="button-prev">
        <img src="@/assets/images/itemDetail/itemDetail-left.svg" alt="left" />
      </div>
      <div class="preview__main__img__right swiper-button-next" slot="button-next">
        <img src="@/assets/images/itemDetail/itemDetail-right.svg" alt="right" />
      </div>
    </swiper>
    <h2 class="preview__main__ttl">{{ item.name }}</h2>
    <p class="preview__main__id" v-if="(basePartsMakerID !== '')">品番: {{ basePartsMakerID }}</p>
    <p class="preview__main__price">¥ {{ customItem.amount | formatPrice(item.tax) }}</p>
  </div>
  <div class="preview__info">
    <h3 class="preview__info__ttl">Information</h3>
    <table class="preview__info__table">
      <template v-for="(info, index) in item.informations">
        <tr :key="index"><th>{{ info.infoLabel }}</th><td v-html="info.infoValue"></td></tr>
      </template>
      <tr v-if="(deliveryDate !== '')">
        <th>{{ (isBuyEC)? 'お届け日': 'お渡し日'}}</th>
        <td>{{ deliveryDate }}</td>
      </tr>
    </table>
  </div>
  <div class="preview__info preview__info--no-border">
    <h3 class="preview__info__ttl">Customize</h3>
    <table class="preview__info__table">
      <tr>
        <th>カスタムID</th>
        <td>{{ customItem['customID'] }}</td>
        <td></td>
      </tr>
      <tr v-for="(part, index) in customItem['parts']" :key="index">
        <th>{{ part['label'] }} &nbsp;</th>
        <td>{{ part['name'] }} {{ showInputText(part['embroidery']) }}</td>
        <td>{{ (part['price'] !== 0 && !part['baseItem'])? '+' : '' }} ¥{{ ((!part['baseItem'])? (part['price']) : 0) | formatPrice(item.tax) }}</td>
      </tr>
    </table>
  </div>

  <div class="preview__sns">
    <div class="preview__sns__ct">
      <a :href="fbUrl" target="_blank" class="preview__sns__ct__item fb">
        <img src="@/assets/images/preview/preview-sns-fb.svg" alt="facebook" />
      </a>
      <a :href="twUrl" class="preview__sns__ct__item tw">
        <img src="@/assets/images/preview/preview-sns-tw.svg" alt="twitter" />
      </a>
      <a :href="lineUrl" class="preview__sns__ct__item line">
        <img src="@/assets/images/preview/preview-sns-line.svg" alt="line" />
      </a>
    </div>
  </div>
  <div class="preview__qr">
    <!-- <h2 class="preview__qr__ttl">スマートミラーと連携する</h2>
    <p class="preview__qr__txt">阪急阪神百貨店うめだ本店1階では、下記カスタムIDをスマートミラーで読み取って頂くと、カスタムした商品を鏡に映し出してデザインをご確認頂くことができます。スマートミラーについての詳細は<router-link to="/howto">こちら</router-link>をご覧ください。</p> -->
    <figure class="preview__qr__img">
      <figcaption>カスタムID: <span>{{ customItem['customID'] }}</span></figcaption>
      <!-- <canvas id="QRCode"></canvas> -->
    </figure>
    <p><span>※商品の判別に必要なIDです。<br>店頭でスタッフに求められた場合はご提示ください。</span></p>
  </div>

  <Footer />
  <button
    class="preview__next"
    v-if="isBuyEC"
    @click="checkBuyItem">この商品を購入する</button>
  <Modal
    v-if="isShowModal"
    :modalObject="modalObject"
    @close="isShowModal = false" />
  <TermsModal
    v-if="isTermsModal"
    @clickClose="isTermsModal = false"
    @buyItem="buyItem" />
</div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TermsModal from '@/components/TermsModal'
import Modal from '@/components/Modal'
import customMgr from '@/modules/CustomManager.js'
import {config} from '@/config.js'

import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import QRCode from 'qrcode'
import {getDeliveryDateString} from '@/modules/utilityFunctions.js'

Vue.use(VueAwesomeSwiper)

export default {
  components: {
    Header,
    Footer,
    Modal,
    TermsModal
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getCustomItem(String(to.params.customID)).then((customItem) => {
      return customItem
    }).then((customItem) => {
      customMgr.getItem(customItem['id']).then((item) => {
        next(vm => {
          vm.setItem(item)
          vm.setCustomItem(customItem)
        })
      }).catch(() => {
        next({ name: 'not-found' })
      })
    }).catch(() => {
      next({ name: 'not-found' })
    })
  },
  data () {
    return {
      customItem: {},
      item: {},
      shareURL: '',
      isTermsModal: false,
      isShowModal: false,
      modalObject: {
        title: '', content: '', routerLink: '', href: '', showNo: false, showOk: true
      },
      deliveryDate: '',
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  props: {
    customID: String
  },
  computed: {
    isBuyEC () {
      const canBuyItem = []
      for (let i in this.customItem.parts) {
        if (this.customItem.parts[i].isEC === false) canBuyItem.push(false)
      }
      if (canBuyItem.length !== 0) {
        return false
      } else {
        return true
      }
    },
    basePartsMakerID () {
      if (typeof this.item.parts !== 'undefined') {
        return this.item.parts.find(el => el.baseItem === true).selects[0].makerID
      }
    },
    fbUrl () {
      return 'https://www.facebook.com/sharer/sharer.php?u=' + this.shareURL
    },
    twUrl () {
      const txt = encodeURIComponent('好きな要素がいっぱい詰まった、自分だけのバッグがほしい！My Custom Bag Studio（マイカスタムバッグスタジオ）はそんな願いを叶えます。')
      return 'https://twitter.com/intent/tweet?text=' + txt + '&hashtags=MyCustomBag' + '&url=' + this.shareURL
    },
    lineUrl () {
      return 'http://line.me/R/msg/text/?' + this.shareURL
    }
  },
  mounted () {
    this.shareURL = encodeURIComponent(config['appURL'] + '/share/' + this.customID)

    QRCode.toCanvas(
      this.$el.querySelector('#QRCode'),
      config['appURL'] + '/mirror/custom?customid=' + this.customID,
      { errorCorrectionLevel: 'H' },
      (error) => { if (error) console.error(error) }
    )
  },
  methods: {
    setItem (item) {
      this.item = item
    },
    setCustomItem (customItem) {
      this.customItem = customItem

      // 納期記述
      this.deliveryDate = getDeliveryDateString(this.customItem['parts'])
    },
    checkBuyItem () {
      if (this.customItem['cartInState'] === false) {
        this.isTermsModal = true
      } else {
        this.modalObject['title'] = '既に購入された商品です'
        this.modalObject['content'] = '初めからカスタマイズするか、MY CUSTOMにコピーされたカスタム商品を再度編集してください。'
        this.isShowModal = true
      }
    },
    buyItem () {
      const ecPostData = customMgr.getECPostData(this.customItem)
      const form = document.createElement('form')

      form.action = config['eStoresURL']
      form.enctype = 'application/x-www-form-urlencoded'
      form.method = 'POST'

      customMgr.duplicateCustomItem(this.customItem['customID'])
        .then(() => {
          this.customItem['cartInState'] = true
          this.customItem['cartInDate'] = new Date().getTime()
        })
        .then(() => {
          customMgr.setCustomItemValue(this.customItem['customID'], 'cartInState', this.customItem['cartInState']).then(() => {
            customMgr.setCustomItemValue(this.customItem['customID'], 'cartInDate', this.customItem['cartInDate']).then(() => {
              for (const key in ecPostData) {
                if (ecPostData.hasOwnProperty(key)) {
                  const value = ecPostData[key]
                  const q = document.createElement('input')
                  q.type = 'hidden'
                  q.name = key
                  q.value = value
                  form.appendChild(q)
                }
                document.body.appendChild(form)
              }
              form.submit()
            })
          }).catch((error) => {
            return new Error(error)
          })
        })
        .catch((error) => {
          return new Error(error)
        })
    },
    showInputText (embroidery) {
      if (typeof embroidery !== 'undefined') {
        return '(' + embroidery['inputText'] + ')'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-navi {
  @include customTitle;
}
.preview {
  padding-bottom: 54px;
  &.is-termsModal {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  &__logo {
    width: 100%;
    height: 80px;
    padding: 20px 50px;
    border-bottom: 1px solid $right-gray;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &__main {
    padding: 15px;
    border-bottom: 1px solid $right-gray;
    &__img {
      position: relative;
      &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 80%;
          object-fit: contain;
        }
      }
      &__left,
      &__right {
        position: absolute;
        top: 50%;
        margin-top: -15px;
        width: 35px;
        height: 35px;
      }
      &__left {
        left: -3px;
      }
      &__right {
        right: -3px;
      }
    }
    &__ttl {
      font-size: 16px;
      font-weight: bold;
      margin-top: 25px;
    }
    &__id {
      margin-top: 8px;
      font-size: 13px;
    }
    &__sub {
      font-size: 13px;
      margin-top: 5px;
    }
    &__price {
      font-size: 20px;
      text-align: right;
      font-weight: bold;
      margin-top: 10px;
    }
  }
  &__info {
    border-bottom: 1px solid $right-gray;
    padding: 0 15px;
    &--no-border {
      border-bottom: none;
    }
    &__ttl {
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
      position: relative;
    }
    &__table {
      width: 100%;
      margin: 0 auto;
      font-size: 14px;
      line-height: 1.5;
      th {
        text-align: left;
        font-weight: bold;
        width: 100px;
        border-top: 2px dotted $right-gray;
        padding: 15px 0;
        vertical-align: middle;
      }
      td {
        border-top: 2px dotted $right-gray;
        vertical-align: middle;
        padding: 15px 0 15px 15px;
        &:nth-child(3) {
          white-space: nowrap;
        }
      }
    }
  }
  &__sns {
    width: calc(100% - 30px);
    margin: 30px auto 40px;
    border-top: 2px solid $dark-gray;
    border-bottom: 2px solid $dark-gray;
    &__ct {
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        padding: 10px;
        margin: 0 5px;
      }
    }
  }
  &__qr {
    padding: 20px 15px;
    background-color: $gray;
    &__ttl {
      color: $base-white;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      position: relative;
      padding-left: 40px;
      &:before {
        content: "";
        position: absolute;
        top: 50%;
        width: 30px;
        height: 30px;
        background: url("../assets/images/preview/preview-mirror.svg") top left
          no-repeat;
        background-size: 30px 30px;
        margin-top: -15px;
        margin-left: -40px;
      }
    }
    &__txt {
      margin-top: 30px;
      font-size: 14px;
      color: $base-white;
      line-height: 1.5;
      a {
        padding: 0 5px;
        color: $base-white;
        text-decoration: underline;
      }
    }
    &__img {
      text-align: center;
      width: 100%;
      margin: 0 auto;

      #QRCode {
        width: 90% !important;
        height: 90% !important;
        border: 2px solid #eeeeee;
      }
      figcaption {
        text-align: center;
        color: $base-white;
        // margin-top: 10px;
        font-size: 18px;
        margin-bottom: 10px;
        padding: 10px 5px;
        border: 2px solid $base-white;
        >span {
          font-weight: bold;
        }
      }
    }
    p {
      color: $base-white;
      font-size: 11px;
      line-height: 1.6;
    }
  }
  &__next {
    width: 100%;
    position: fixed;
    display: block;
    bottom: 0;
    cursor: pointer;
    border: none;
    z-index: 99;
    background-color: $blue;
    padding: 15px 0;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    color: $base-white;
    border: none !important;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 15px;
      width: 26px;
      height: 26px;
      background: url("../assets/images/preview/preview-cart.svg") top left
        no-repeat;
      background-size: 26px 26px;
      margin-top: -13px;
    }
  }
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
  background-image: none;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  background-image: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/Preview.vue